import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import L from "leaflet";

// Fix default icons (unused since we use CircleMarker, but future-proof)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function MapView({ points = [], center = [20, 10], zoom = 2, height = 380 }) {
  return (
    <div style={{ height }} className="rounded-2xl overflow-hidden border border-white/5" data-testid="leaflet-map">
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {points.map((p, i) => (
          <CircleMarker
            key={i}
            center={[p.lat, p.lng]}
            radius={Math.max(6, (p.value || 6))}
            pathOptions={{ color: "#EDE4CE", fillColor: "#EDE4CE", fillOpacity: 0.55, weight: 1.5 }}
          >
            <Popup>
              <div style={{ minWidth: 160 }}>
                <div style={{ fontFamily: "Playfair Display, serif", fontSize: 16, color: "#EDE4CE" }}>{p.name}</div>
                {p.detail && <div style={{ fontSize: 12, marginTop: 4, color: "#ddd" }}>{p.detail}</div>}
                {p.value !== undefined && <div style={{ fontSize: 11, marginTop: 6, color: "#888", fontFamily: "JetBrains Mono, monospace" }}>Index: {p.value}</div>}
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
